import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { onMessageListener } from "../../utils/pushNotification";

import { toastMessage } from "../../utils/toast";
import { clearSession } from "../../utils/initiate";
import * as localizationActions from "../../Redux/Actions/localization";
import NeedHelpModal from "../Ui/NeedHelpModal/NeedHelpModal";


const BiometricTracking = ({ history }) => {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const [fcmToken, setFcmToken] = useState("");
    const [showHelpModal, setShowHelpModal] = useState(false);
    const [currentLanguage, setCurrentLanguage] = useState(
        localStorage.getItem("i18nextLng")
    );

    onMessageListener().then(payload => {
        console.log(payload);
    }).catch(err => console.log('failed: ', err));

    useEffect(() => {
        //To Get English Localizations
        localizationActions
            .localization("EN")
            .then((res) => {
                if (res) {
                    setTimeout(() => {
                        localStorage.setItem("localEn", JSON.stringify(res));
                    }, 10);
                } else {
                    localStorage.setItem("localEn", "");
                    toastMessage(
                        "error",
                        (res && res.message) || `Unable to load the eng Localization`
                    );
                }
            })
            .catch((err) => {
                err.response?.status === 401 && clearSession(dispatch, history);
            });
        //-----------------------------------------------------------------------------------------------------
        //To Get Arabic Localizations
        localizationActions
            .localization("AR")
            .then((res) => {
                if (res) {
                    localStorage.setItem("localAr", JSON.stringify(res));
                } else {
                    localStorage.setItem("localAr", "");
                    toastMessage(
                        "error",
                        (res && res.message) || `Unable to load the ar Localization`
                    );
                }
            })
            .catch((err) => {
                err.response?.status === 401 && clearSession(dispatch, history);
            });

    }, []);

    const changeLanguage = (value) => {
        i18n.changeLanguage(value);
        setCurrentLanguage(value);
    };

    const [cardHeight, setCardHeight] = useState("300px");

    useEffect(() => {
        const updateHeight = () => {
            if (window.innerWidth <= 768) {
                setCardHeight("auto"); // mobile height
            } else {
                setCardHeight("330px"); // desktop height
            }
        };

        updateHeight();
        window.addEventListener("resize", updateHeight);
        return () => window.removeEventListener("resize", updateHeight);
    }, []);

    return (
        <div className="d-flex flex-column  vh-100" style={{ minHeight: "100%", background: "#f8f9fa" }}>
            <div
                className="container-fluid px-3"
                style={{
                    width: "100%",
                    paddingTop: "1px",
                    paddingBottom: "20px",
                }}
            >
                <div className="row align-items-center justify-content-between">

                    <div
                        className="col-12 col-md-6 d-flex justify-content-center justify-content-md-start align-items-center flex-wrap"
                        style={{ gap: "20px" }}
                    >
                        <img
                            src="/Assets/aamer_logistics_logo.png"
                            alt="logo"
                            style={{
                                width: "35vw",
                                maxWidth: "130px",
                                marginTop: "73px",
                            }}
                        />
                        <img
                            src="/Assets/icp-logo.png"
                            alt="logo"
                            style={{
                                width: "35vw",
                                maxWidth: "130px",
                                height: "auto",
                            }}
                        />
                    </div>

                    {/* Language Toggle - Desktop right / Mobile bottom-center */}
                    <div
                        className="col-12 col-md-6 d-flex justify-content-center justify-content-md-end  mt-3 mt-md-0"
                        style={{ gap: "10px" }}
                    >
                        <span
                            style={{
                                fontSize: "20px",
                                color: "#29235c",
                                cursor: "pointer",
                                borderBottom: currentLanguage === "english" ? "2px solid" : "0px",
                                fontWeight: "bold",
                            }}
                            onClick={() => changeLanguage("english")}
                        >
                            EN
                        </span>
                        <span
                            style={{
                                fontSize: "20px",
                                color: "#29235c",
                                fontWeight: "bold",
                            }}
                        >
                            |
                        </span>
                        <span
                            style={{
                                fontSize: "20px",
                                color: "#29235c",
                                cursor: "pointer",
                                borderBottom: currentLanguage === "arabic" ? "2px solid" : "0px",
                                fontWeight: "bold",
                            }}
                            onClick={() => changeLanguage("arabic")}
                        >
                            AR
                        </span>
                    </div>

                </div>
            </div>


            <div
                className="container-fluid px-2 px-md-5"
                style={{
                    marginTop: "10px",
                }}
            >
                <style>
                    {`
                        @media (max-width: 767.98px) {
                            .container-fluid.px-2.px-md-5 {
                                margin-top: 7% !important;
                            }
                        }   
                    `}
                </style>
                <div className="row d-flex justify-content-center">
                    <div className="col-12 align-self-center">
                        <div className="row">
                            <div className="col-12 mx-auto" >
                                <h1 className="text-2xl text-center font-bold " style={{ fontSize: "2rem", color: "#29235c" }}>
                                    {currentLanguage === "arabic" ? (
                                        <>
                                            <b>مركز القياسات الحيوية / </b>عملية التتبع
                                        </>
                                    ) : (
                                        <>
                                            <b>Biometric Center / </b>Tracking Process
                                        </>
                                    )}
                                </h1>
                            </div>
                        </div>
                        <div className="card " style={{ backgroundColor: "#29235c", border: "none", height: cardHeight }}>
                            <div className="card-body p-0 auth-header-box-biometric">
                                <div className="text-center p-3">
                                    {/* Steps for desktop */}
                                    <div className="d-none d-md-flex row align-items-center justify-content-center flex-nowrap" style={{ overflowX: "auto", marginTop: "45px" }}>
                                        <div className="col-12 col-md-3 d-flex flex-column align-items-center mb-3 mb-md-0">
                                            <span
                                                style={{
                                                    fontSize: "3.5rem",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    color: "#fff",
                                                }}
                                            >
                                                <img src="/Assets/biometric-tracking-card.png" alt="Payment Icon" style={{ width: "170px", height: "150px" }} />
                                            </span>
                                            <div className="d-flex align-items-center mt-2">
                                                <h6 className="fw-semibold text-white mb-0 text-center" style={{ fontSize: "1.2rem", minWidth: "130px" }}>
                                                    <b>{currentLanguage === "arabic" ? "1. إتمام الدفع" : "1. Payment Completed"}</b>
                                                </h6>
                                            </div>
                                        </div>
                                        <div className="col-auto d-flex justify-content-center align-items-center px-1">
                                            <span
                                                style={{
                                                    fontSize: "2.2rem",
                                                    backgroundColor: "#fff",
                                                    borderRadius: "1px",
                                                    padding: "2px 4px",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    color: "#29235c",
                                                    boxShadow: "0 2px 8px rgba(44,56,94,0.08)"
                                                }}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" fill="currentColor" className="bi bi-arrow-right-square" viewBox="0 0 16 16">
                                                    <path fillRule="evenodd" d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm4.5 5.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z" />
                                                </svg>
                                            </span>
                                        </div>
                                        <div className="col-12 col-md-3 d-flex flex-column align-items-center mb-3 mb-md-0">
                                            <span
                                                style={{
                                                    fontSize: "3.5rem",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    color: "#fff",
                                                }}
                                            >
                                                <img src="/Assets/biometric-tracking_center.png" alt="Service Center Icon" style={{ width: "170px", height: "150px" }} />
                                            </span>
                                            <div className="d-flex align-items-center mt-2">
                                                <h6 className="fw-semibold text-white mb-0 text-center" style={{ fontSize: "1.2rem", minWidth: "180px" }}>
                                                    <b>{currentLanguage === "arabic" ? "2. زيارة مركز الخدمة للقياسات الحيوية" : "2. Visiting the Service Center for the Biometric"}</b>
                                                </h6>
                                            </div>
                                        </div>
                                        <div className="col-auto d-flex justify-content-center align-items-center px-1">
                                            <span
                                                style={{
                                                    fontSize: "2.2rem",
                                                    backgroundColor: "#fff",
                                                    borderRadius: "1px",
                                                    padding: "2px 4px",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    color: "#29235c",
                                                    boxShadow: "0 2px 8px rgba(44,56,94,0.08)"
                                                }}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" fill="currentColor" className="bi bi-arrow-right-square" viewBox="0 0 16 16">
                                                    <path fillRule="evenodd" d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm4.5 5.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z" />
                                                </svg>
                                            </span>
                                        </div>
                                        <div className="col-12 col-md-3 d-flex flex-column align-items-center">
                                            <span
                                                style={{
                                                    fontSize: "3.5rem",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    color: "#fff",
                                                }}
                                            >
                                                <img src="/Assets/biometric-tracking_completed.png" alt="Biometric Completed Icon" style={{ width: "170px", height: "150px" }} />
                                            </span>
                                            <div className="d-flex align-items-center mt-2">
                                                <h6 className="fw-semibold text-white mb-0 text-center" style={{ fontSize: "1.2rem", minWidth: "100px" }}>
                                                    <b>{currentLanguage === "arabic" ? "3. إتمام القياسات الحيوية" : "3. Biometric Completed"}</b>
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Mobile view: steps stacked vertically, text and icons on separate lines */}
                                    <div className="d-flex d-md-none flex-column align-items-center justify-content-center biometric-mobile-steps">
                                        <span
                                            style={{
                                                fontSize: "3.5rem",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                color: "#fff",
                                            }}
                                        >
                                            <img src="/Assets/biometric-tracking-card.png" alt="Payment Icon" style={{ width: "170px", height: "120px" }} />
                                        </span>
                                        <div className="d-flex flex-column align-items-center mb-2">
                                            <span className="fw-semibold text-white text-center" style={{ fontSize: "1.1rem" }}>
                                                <b>{currentLanguage === "arabic" ? "1. إتمام الدفع" : "1. Payment Completed"}</b>
                                            </span>
                                            <span
                                                style={{
                                                    fontSize: "2.2rem",
                                                    backgroundColor: "#fff",
                                                    borderRadius: "1px",
                                                    padding: "2px 4px",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    color: "#29235c",
                                                    boxShadow: "0 2px 8px rgba(44,56,94,0.08)",
                                                    margin: "8px 0"
                                                }}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" fill="currentColor" className="bi bi-arrow-down-square" viewBox="0 0 16 16">
                                                    <path fillRule="evenodd" d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm7.5 4.5a.5.5 0 0 1 1 0v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 12.293V6.5z" />
                                                </svg>
                                            </span>
                                        </div>
                                        <div className="d-flex flex-column align-items-center mb-2">
                                            <span
                                                style={{
                                                    fontSize: "3.5rem", // reduced from 2.2rem
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    color: "#fff",
                                                }}
                                            >
                                                <img src="/Assets/biometric-tracking_center.png" alt="Service Center Icon" style={{ width: "170px", height: "120px" }} />
                                            </span>
                                            <span className="fw-semibold text-white text-center mt-2" style={{ fontSize: "1.1rem" }}>
                                                <b> {currentLanguage === "arabic" ? "2. زيارة مركز الخدمة للقياسات الحيوية" : "2. Visiting the Service Center for the Biometric"}</b>
                                            </span>
                                            <span
                                                style={{
                                                    fontSize: "2.2rem",
                                                    backgroundColor: "#fff",
                                                    borderRadius: "1px",
                                                    padding: "2px 4px",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    color: "#29235c",
                                                    boxShadow: "0 2px 8px rgba(44,56,94,0.08)",
                                                    margin: "8px 0"
                                                }}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" fill="currentColor" className="bi bi-arrow-down-square" viewBox="0 0 16 16">
                                                    <path fillRule="evenodd" d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm7.5 4.5a.5.5 0 0 1 1 0v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 12.293V6.5z" />
                                                </svg>
                                            </span>
                                        </div>
                                        <div className="d-flex flex-column align-items-center">
                                            <span
                                                style={{
                                                    fontSize: "3.5rem",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    color: "#fff",
                                                }}
                                            >
                                                <img src="/Assets/biometric-tracking_completed.png" alt="Biometric Completed Icon" style={{ width: "170px", height: "130px" }} />
                                            </span>
                                            <span className="fw-semibold text-white text-center" style={{ fontSize: "1.1rem" }}>
                                                <b> {currentLanguage === "arabic" ? "3. إتمام القياسات الحيوية" : "3. Biometric Completed"}</b>
                                            </span>
                                        </div>

                                        {/* Responsive vertical stacking for steps on mobile */}
                                        <style>
                                            {`
                                        @media (max-width: 767.98px) {
                                            .card .row.flex-nowrap {
                                                display: none !important;
                                            }
                                            .d-md-flex {
                                                display: none !important;
                                            }
                                            .d-md-none {
                                                display: flex !important;
                                            }
                                            .biometric-mobile-steps > div {
                                                margin-bottom: 18px;
                                            }
                                            .biometric-mobile-steps > div:last-child {
                                                margin-bottom: 0;
                                            }
                                        }
                                        @media (min-width: 768px) {
                                            .d-md-flex {
                                                display: flex !important;
                                            }
                                            .d-md-none {
                                                display: none !important;
                                            }
                                        }
                                        `}
                                        </style>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mt-4 row">
                            <p className="text-black col" style={{ fontSize: "1.2rem" }}>
                                <b style={{ color: "#D90F15" }}>{currentLanguage === "arabic" ? "الحالة" : "Status"}</b>
                            </p>
                            <p className="text-black col" style={{ fontSize: "1.2rem" }}>
                                <span
                                    style={{
                                        fontWeight: "bold",
                                        color: "#29235c",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        fontSize: "2.5rem",
                                        verticalAlign: "middle"
                                    }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="30" fill="rgb(11,1,70)" className="bi bi-check-lg" viewBox="0 0 16 16">
                                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                                    </svg>

                                </span>
                            </p>
                            <p className="text-black col" style={{ fontSize: "1.2rem" }}>

                            </p>
                            <p className="text-black col" style={{ fontSize: "1.2rem" }}>

                            </p>
                            <p className="text-black col" style={{ fontSize: "1.2rem" }}>

                            </p>
                        </div>
                        <div className="col-12">
                            <span
                                className=""
                                style={{
                                    color: "#29235c",
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                    fontSize: "18px",
                                }}
                                onClick={() => setShowHelpModal(true)}
                            >
                                {currentLanguage === "arabic" ? "مساعدة؟" : "Need Help?"}
                            </span>
                        </div>
                    </div>
                </div>


            </div>
            {showHelpModal && (
                <NeedHelpModal
                    t={t}
                    handleCancel={() => {
                        setShowHelpModal(false);
                    }}
                    history={history}
                    showModal={showHelpModal}
                    footerOption1={"Submit"}
                    footerOption2={"Cancel"}
                    type={"help"}
                >
                    {" "}
                </NeedHelpModal>
            )}
        </div>
    );
};

export default BiometricTracking;
